import React, {useContext} from 'react';
import {FabricJSCanvas, useFabricJSEditor} from "fabricjs-react";
import ImageUploading from 'react-images-uploading';
import {fabric} from 'fabric';

import './style.css';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {uploadImg} from "../../../../api/benefits";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {dataURItoBlob} from '@services/helper';
import Typography from "@mui/material/Typography";

export const CanvasAddImage = ({data, handleClose, languageIndex=1}) => {
    const label = 'Please upload file 640x400'
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const {editor, onReady} = useFabricJSEditor();

    const [images, setImages] = React.useState([]);
    const maxNumber = 69;

    const clearCanvas = () => {
        editor.canvas.clear();
        editor.canvas.renderAll();
        editor.canvas.remove(...editor.canvas.getObjects());
    }

    const onChange = (imageList) => {
        setImages(imageList);
        if (!imageList.length) return clearCanvas();

        const {data_url} = imageList[0];

        var imgObj = new Image();
        imgObj.src = data_url;
        imgObj.onload = function () {
            var image = new fabric.Image(imgObj);
            image.originX = 'center';
            image.originY = 'center';

            if (image.width > image.height) {
                image.scaleToWidth(editor.canvas.getWidth());
            } else {
                image.scaleToHeight(editor.canvas.getHeight());
            }

            editor.canvas.add(image);
            editor.canvas.centerObject(image);
            editor.canvas.setActiveObject(image);
            editor.canvas.renderAll();
        }
    };

    const handleSubmit = async (event) => {

        try {
            setLoading(true);
            setErrorMessage(null);

            const image = editor.canvas.toDataURL();
            const input = new FormData();
            input.append('image', dataURItoBlob(image));
            input.append('languageIndex', languageIndex);
            await uploadImg(data.id, input);
            handleClose(event, data);

        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    return (
        <Box
            className={'add-image'}
            style={{'position': 'relative'}}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <Typography fontSize={22} component="h3">{label}</Typography>
            <ImageUploading
                value={images}
                onChange={onChange}
                maxNumber={maxNumber}
                dataURLKey="data_url"
            >
                {({
                      imageList,
                      onImageUpload,
                      onImageRemove,
                      isDragging,
                      dragProps,
                  }) => (
                    <Box
                        className={images.length ? 'load hidden' : 'load'}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <button
                            style={isDragging ? {color: 'red'} : {}}
                            onClick={onImageUpload}
                            {...dragProps}
                        >
                            Click or Drop here
                        </button>
                        &nbsp;
                        {imageList.map((image, index) => (
                            <div key={index} className="image-item">
                                <img src={image['data_url']} alt="" width="100"/>
                                <div className="image-item__btn-wrapper">
                                    <button onClick={() => onImageRemove(index)}>Remove</button>
                                </div>
                            </div>
                        ))}
                    </Box>
                )}
            </ImageUploading>
            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
            >
                <FabricJSCanvas className={data.type.toLowerCase()} onReady={onReady}/>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                >
                    Add
                </Button>
            </Box>
        </Box>
    )
}
